import { render } from "./ChatRoom.vue?vue&type=template&id=b5aff13e&ts=true"
import script from "./ChatRoom.vue?vue&type=script&lang=ts"
export * from "./ChatRoom.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__